module.exports = __webpack_public_path__ + "static/media/profileImgBig.e739ad5e.svg";